import { FC } from 'react';
import { Label, Radio } from '@qga/roo-ui/components';
import { RefundType } from 'lib/graphql';

interface RefundOptionsProps {
  onChange: (value: RefundType) => any;
  value: RefundType;
  activeValue: RefundType;
}

const RefundOptionField: FC<RefundOptionsProps> = ({ children, onChange, value, activeValue }) => (
  <Label textStyle="text">
    <Radio name="refundMethod" checked={activeValue === value} value={value} onChange={() => onChange(value)} />
    {children}
  </Label>
);

export default RefundOptionField;
